import { createActionCreators, createReducerFunction, ImmerReducer } from 'immer-reducer';
import { IDeviceConfigurationDictionary } from 'src/device-status/interfaces/IDeviceConfigurationDictionary';
import { IPinpadState, ThirdPartyData } from '../../interfaces/states/IPinpadState';

const initialState: IPinpadState = {
  isPinpadConfigured: false,
  hasCardData: false,
};

export class PinPadReducer extends ImmerReducer<IPinpadState> {
  public setIsPinpadConfigured(isConfigured: boolean): void {
    this.draftState.isPinpadConfigured = isConfigured;
  }
  public setSessionTranId(sessionTransactionId: string): void {
    this.draftState.sessionTransactionId = sessionTransactionId;
  }
  public removeSessionTranId(): void {
    this.draftState.sessionTransactionId = undefined;
  }
  public resetState(): void {
    this.draftState = initialState;
  }
  public setHasCardData(hasCardData: boolean): void {
    this.draftState.hasCardData = hasCardData;
  }
  public setPaymentTransactionId(paymentTransactionId: string): void {
    this.draftState.paymentTransactionId = paymentTransactionId;
  }
  public setThirdPartyData(thirdPartyData: ThirdPartyData): void {
    this.draftState.thirdPartyData = {
      ...this.draftState.thirdPartyData,
      ...thirdPartyData,
    };
  }
  public resetThirdPartyData(): void {
    this.draftState.thirdPartyData = undefined;
  }
  public setConfiguration(config?: IDeviceConfigurationDictionary): void {
    this.draftState.configuration = config;
  }
  public resetConfiguration(): void {
    this.draftState.configuration = undefined;
  }
}

export const PinPadActions = createActionCreators(PinPadReducer);
export const PinPadReducerFunction = createReducerFunction(PinPadReducer, initialState);
